<template>
  <v-dialog ref="dialog" v-model="modal2" :return-value.sync="manualInputTime" @click:outside="closeDialog" width="350px">
    <template v-slot:activator="{ on }">
      <v-text-field v-model="manualInputTime" :label="label" class="centered-input mx-2" :disabled="disabled" :rules="rules" readonly v-on="on">
        <template slot="prepend-inner">
          <v-icon large @click="setAddMinit2Time(-1)" :color="!disabled ? color : ''" :style="{ cursor: 'pointer' }">mdi-arrow-left</v-icon>
        </template>
        <template slot="append">
          <v-icon large @click="setAddMinit2Time(1)" :color="!disabled ? color : ''" :style="{ cursor: 'pointer' }">mdi-arrow-right</v-icon>
        </template>
      </v-text-field>
    </template>

    <v-time-picker
      format="24hr"
      v-model="currentTime"
      @input="manualInputTime = currentTime"
      @click:hour="hourSelected"
      :max="max"
      :min="min"
      :disabled="disabled"
    >
      <v-col cols="12" class="px-2 py-0 ma-0">
        <v-row justify="center">
          <v-col cols="6">
            <v-text-field
              ref="text"
              label="Zeit eingeben"
              v-model="manualInputTime"
              class="centered-input"
              @keypress.native="isNumber()"
              @keyup.enter.native="closeDialog()"
              @keyup.left.native="setAddMinit2Time(-1)"
              @keyup.right.native="setAddMinit2Time(1)"
              @keyup.up.native="setAddMinit2Time(60)"
              @keyup.down.native="setAddMinit2Time(-60)"
              autocomplete="off"
              :autofocus="true"
              v-if="!showManualInputField"
            ></v-text-field>
          </v-col>
        </v-row>
        <v-row justify="center" no-gutters>
          <v-col class="text-center px-2 py-0 mb-2">
            <v-btn text @click="modal2 = false">Cancel</v-btn>
          </v-col>
          <v-col class="text-center px-2 py-0 mb-2">
            <v-btn text @click.native="closeDialog()">OK</v-btn>
          </v-col>
        </v-row>
      </v-col>
    </v-time-picker>
  </v-dialog>
</template>
<script>
import moment from "moment";
export default {
  data() {
    return {
      modal2: false,
      currentTime: "",
      color: "primary",
      manualInputTime: null
    };
  },
  props: {
    label: {
      type: String,
      default: ""
    },
    time: {
      type: String,
      default: ""
    },
    min: {
      type: String,
      default: ""
    },
    max: {
      type: String,
      default: ""
    },
    disabled: {
      type: Boolean,
      default: false
    },
    showManualInputField: {
      type: Boolean,
      default: false
    },
    rules: {
      type: Array
    }
  },
  created: function () {
    this.currentTime = this.time;
    this.manualInputTime = "";
  },

  methods: {
    closeDialog() {
      this.Dialog = false;
      this.currentTime = Helper.addMinit2Time(this.currentTime, 0, this.min, this.max);
      this.$emit("change", this.currentTime);
      this.$emit("next");
      this.manualInputTime = "";
      this.$refs.dialog.save(this.currentTime);
    },
    setAddMinit2Time(minit) {
      if (!this.disabled) {
        this.currentTime = Helper.addMinit2Time(this.currentTime, minit, this.min, this.max);

        this.$emit("change", this.currentTime);
      }
    },
    hourSelected(val) {
      this.currentTime = moment(val, "HH").format("HH:mm");
    },
    isNumber(evt) {
      evt = evt ? evt : window.event;

      let charCode = evt.which ? evt.which : evt.keyCode;

      if (charCode > 31 && (charCode < 48 || charCode > 57)) {
        evt.preventDefault();
      } else if (charCode == 46 || charCode == 13) {
        evt.preventDefault();
        return false;
      } else {
        evt.preventDefault();
        if (!this.disabled) {
          if (this.manualInputTime == null || this.manualInputTime.length == 0) {
            if (parseInt(evt.key) > 2 && parseInt(evt.key) < 10) {
              this.manualInputTime += "0" + evt.key + ":";
            } else {
              this.manualInputTime += evt.key;
            }
          } else if (this.manualInputTime.length == 1) {
            if (this.manualInputTime == 2 && parseInt(evt.key) >= 4) {
              if (parseInt(evt.key) <= 5) {
                this.manualInputTime = "02:" + evt.key;
              } else {
                this.manualInputTime = "02:5";
              }
            } else {
              this.manualInputTime += evt.key + ":";
            }
          } else if (this.manualInputTime.length == 2) {
            if (parseInt(evt.key) >= 5) {
              this.manualInputTime += ":5";
            } else {
              this.manualInputTime += ":" + evt.key;
            }
          } else if (this.manualInputTime.length == 3) {
            if (parseInt(evt.key) >= 5) {
              this.manualInputTime += "5";
            } else {
              this.manualInputTime += evt.key;
            }
          } else if (this.manualInputTime.length <= 4) {
            this.manualInputTime += evt.key;
          } else if (this.manualInputTime.length >= 5) {
            if (parseInt(evt.key) > 2 && parseInt(evt.key) < 10) {
              this.manualInputTime = "0" + evt.key + ":";
            } else {
              this.manualInputTime = "02:5";
            }
          } else {
            this.manualInputTime += evt.key + ":";
          }
        } else if (this.manualInputTime.length == 2) {
          if (parseInt(evt.key) >= 5) {
            this.manualInputTime += ":5";
          } else {
            this.manualInputTime += ":" + evt.key;
          }
        } else if (this.manualInputTime.length == 3) {
          if (parseInt(evt.key) >= 5) {
            this.manualInputTime += "5";
          } else {
            this.manualInputTime += evt.key;
          }
        } else if (this.manualInputTime.length <= 4) {
          this.manualInputTime += evt.key;
          this.currentTime = moment(this.manualInputTime, "HH:mm").format("HH:mm");
        } else if (this.manualInputTime.length >= 5) {
          if (parseInt(evt.key) > 2 && parseInt(evt.key) < 10) {
            this.manualInputTime = "0" + evt.key + ":";
          } else {
            this.manualInputTime = evt.key;
          }
        }
        return true;
      }
    }
  },
  model: {
    prop: "time",
    event: "change"
  },
  watch: {
    time() {
      this.currentTime = this.time;
      if (this.currentTime == null) this.manualInputTime = "";
    },
    min() {
      let time = moment(this.currentTime, "HH:mm");
      let minTime = moment(this.min, "HH:mm");
      if (time.isBefore(minTime)) {
        this.currentTime = this.min;
      }
    },
    manualInputTime(val) {
      if (val.length == 5) this.currentTime = val;
    }
  }
};
//@ sourceURL=TimePicker.js
</script>
